'use client';

import { Fragment } from 'react';

export interface BreadcrumbItem {
  label: string;
  isActive?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

/**
 * 재사용 가능한 Breadcrumb 컴포넌트
 *
 * @example
 * <Breadcrumb
 *   items={[
 *     { label: '마스터 관리' },
 *     { label: '계정 관리', isActive: true }
 *   ]}
 * />
 */
export function Breadcrumb({ items, className = '' }: BreadcrumbProps) {
  return (
    <div
      className={`flex items-center space-x-2 text-sm text-muted-foreground ${className}`}
    >
      {items.map((item, index) => (
        <Fragment key={`${item.label}-${index}`}>
          {index > 0 && <span>/</span>}
          <span
            className={
              // 별도 제목 줄이 없으므로 마지막 항목이 페이지 제목 역할을 한다.
              item.isActive ? 'font-semibold text-foreground' : undefined
            }
          >
            {item.label}
          </span>
        </Fragment>
      ))}
    </div>
  );
}
